<template>
    <div>
        <TitleBar>
            <template v-slot:title>
                <translate>Documents</translate>
            </template>
            <template v-slot:buttons>
                <GekkoButton 
                    @click="upload()" 
                    :text="$gettext('Upload')" 
                    icon="fa-solid fa-upload"
                    variant="primary"
                    class="ml-2 my-2"/>
                <GekkoButton 
                    @click="share()" 
                    :text="$gettext('Share')" 
                    icon="fa-solid fa-share"
                    variant="outline-primary"
                    class="ml-2 my-2"/>
            </template>
        </TitleBar>
        <div class="content">
            <DocumentsTable />
        </div>
    </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import DocumentsTable from "@/components/documents/DocumentsTable";

export default {
    name: "Documents",
    components: {TitleBar, GekkoButton, DocumentsTable},
    methods: {
        upload() {
            this.$router.push({name: 'AddDocument'});
        },
        share() {
            this.$router.push({name: 'ShareDocument'});
        }
    }
}
</script>

<style scoped>
</style>